// Accepted runs in the selected local-time window, grouped by production date,
// shift, crew and mapped product (or the unresolved PLC description).
export interface StraightenerKpiRow {
	// A production-date label, rendered without timezone conversion.
	ProductionDate: string | null;
	// "D" or "N".
	ProductionShift: string | null;
	// "A" to "D". Null when the shift had no crew on the roster.
	CrewId: string | null;
	// Null for rows the straightener ran without a product size resolved.
	ProductSize: string | null;
	ProductSizeId: number | null;
	PlcProductDescription: string | null;
	ProductMappingIssue: string | null;
	// Passes, not the number of individual bars in each layer.
	Count: number | null;
	// Recorded PLC gap in seconds; unavailable observations are excluded from averages.
	GapTimeMin: number | null;
	GapTimeMax: number | null;
	GapTimeAvg: number | null;
	// Feet per minute: what the line was set to, and what it measured.
	FPMSet: number | null;
	FPMCalibrated: number | null;
	EstimatedDurationAvgSeconds: number | null;
	TargetBarsPerLayerMin: number | null;
	TargetBarsPerLayerMax: number | null;
	BarLengthAvgFeet: number | null;
}

export interface ProductSizeOption {
	Id: number;
	Name: string;
	ProductTypeId?: number | null;
	ProductTypeName?: string | null;
}

// All clears the filter; -1 selects unresolved PLC products.
export const ALL_PRODUCT_SIZE_ID = -2;
export const NO_PRODUCT_SIZE_ID = -1;

export const ALL_PRODUCT_SIZE_OPTION: ProductSizeOption = {
	Id: ALL_PRODUCT_SIZE_ID,
	Name: "All",
};

export const NO_PRODUCT_SIZE_OPTION: ProductSizeOption = {
	Id: NO_PRODUCT_SIZE_ID,
	Name: "Unmatched (PLC)",
};

// Both lists are hardcoded in the legacy screen too: neither is fetched.
export const SHIFT_OPTIONS = ["D", "N"] as const;
export const CREW_OPTIONS = ["A", "B", "C", "D"] as const;
